import axios from 'axios'

export default {
    created: function() {
        /* 回答を初期化する */
        /*
        if(this.$store.state.answerData == null) {
            this.$set(this.$store.state, 'answerData', Array
                .apply(null, Array(this.getTotalLength()))
                .map(function () { return -1; }));
        }
        */
       /* TODO: とりあえず30で作る */
       if(this.$store.state.answerData == null) {
        this.$set(this.$store.state, 'answerData', Array(30));
       }
    },
    methods: {

        /* 全体問題番号 to i(カテゴリ番号), j(問題番号) */
        q2ij: function(q, categories) {
            return this.q2ijMap.get(q, categories);
        },
        /* i(カテゴリ番号), j問題番号 to (問題番号) */
        ij2q: function(i, j, categories) {
            return this.ij2qTable(categories)[i][j];
        },
        /* ij2label はい, いいえなどのラベルにする */
        ij2label: function(i, j) {
            const answerIndex = this.$store.state.answerData[this.ij2q(i, j)];
            if(answerIndex<0) return '未選択';
            return this.$store.state.json.options[answerIndex];
        },
        /* 点数計算 */
        getScore: function () {
            return this.getScores().reduce((acc, val) => acc + val);
        },
        
        /* 変換テーブルの取得 */
        q2ijMap: function(categories) {
            let cnt = 0;
            const retVal = new Map();
            for(let i=0; i<categories.length; i++) {
                for(let j=0; j<categories[i].q.length; j++) {
                    retVal.set(cnt++, [i, j]);
                }
            }
            return retVal;
        },
        ij2qTable: function(categories) {
            const retVal = [];
            let cnt = 0;
            for(let i=0; i<categories.length; i++) {
                retVal.push([]);
                for(let j=0; j<categories[i].q.length; j++) {
                    retVal[i].push(cnt++);
                }
            }
            return retVal;
        },
    }

}